module.exports = __webpack_public_path__ + "static/media/the-secrets-we-kept.5598732c.jpg";